import EventBus from "@packages/event-bus";
import store from "@packages/store";
import axios from "axios";
import _ from "lodash";
import auth from "../auth";
import qs from 'qs';

export default {
    install(Vue) {
        // Add request interceptor
        axios.interceptors.request.use(
            (request) => {
                //Using qs lib to serialize query params in a way that characters '[' and ']' are also encoded
                request.paramsSerializer = (params) => {
                    const nonNullParams = Object.keys(params).reduce((result, key) => {
                        if (params[key] !== null) {
                            result[key] = params[key];
                        }
                        return result;
                    }, {});
                    return qs.stringify(nonNullParams, { arrayFormat: 'brackets' });
                };


                request = this.addBaseUrl(request);
                request = this.mapGetParams(request);

                store.commit("SET_LOADING");

                return request;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        // Add response interceptor
        axios.interceptors.response.use(
            (response) => {
                store.commit("SET_LOADED");
                if (
                    response &&
                    response.data &&
                    (response.data.response ||
                        response.data.response == 0 ||
                        response.data.response === null)
                ) {
                    if (
                        response.data.message &&
                        response.config.method !== "get"
                    ) {
                        EventBus.$emit("show-message", {
                            type: "SUCCESS",
                            message: response.data.message,
                        });
                    }
                    return response.data.response;
                }

                // if (response && response.data) return response.data;

                return response.data;
            },
            async (error) => {
                store.commit("SET_LOADED");

                if (error.config && error.config.skipErrorHandling) {
                    return Promise.reject(error);
                }

                const request = error.request || {};
                const response = error.response;
                const responseURL = request.responseURL || "";

                const isIntergrationError = responseURL.includes('/integration');
                const isTrialEnv = process.env.NODE_ENV === 'trial';
                const hideIntegrationError = isTrialEnv && isIntergrationError;

                if(response && response.status === 403) {
                    auth.logout();
                    window.location.href = '/login';
                }

                if (request.responseType === "blob") {
                    const mapedError = await this.mapBlobError(error);

                    if(!hideIntegrationError) {
                        EventBus.$emit("show-message", {
                            type: "ERROR",
                            message: mapedError.message,
                        });
                    }

                    return Promise.reject(mapedError);
                }

                let message = error.message;

                if (response && response.status == 401) {
                    if (!responseURL.endsWith("login")) {
                        //window.location.href = "/logout";
                    }
                }
                if (response && response.data) {
                    const data = response.data;

                    if (
                        data.errors &&
                        data.errors[0] &&
                        data.errors[0].mensagem
                    ) {
                        message = data.errors[0].mensagem;
                    } else if (data.message) {
                        message = data.message;
                    }
                }

                if(response && response.status !== 404 && !hideIntegrationError) {
                    EventBus.$emit("show-message", {
                        type: "ERROR",
                        message: message,
                    });
                }



                return Promise.reject(error);
            }
        );

        Vue.prototype.$http = Vue.http = axios;
        Vue.prototype.$axios = Vue.axios = axios;
    },

    addBaseUrl(request) {
        if (
            !request.url.includes("http://") &&
            !request.url.includes("https://")
        )
            request.url = process.env.VUE_APP_BACK_END_URL + request.url;

        return request;
    },

    /**
     *
     * This function is required because Java can't parse an url like:
     * &param[]=123&param[]=456
     * so it transforms that into:
     * &param="123,456"
     *
     * @param request
     * @returns {*}
     */
    mapGetParams(request) {
        if (request.method !== "get") return request;

        _.forEach(request.params, (value, key) => {
            const isArray = value instanceof Array;

            if (!isArray) return;

            request.params[key] = _.reduce(value, (result, item) => {
                if (!result) return item;

                return result + "," + item;
            });
        });

        return request;
    },

    /**
     * This function is required to map blob return type errors
     */
    mapBlobError(error) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = () => {
                error = JSON.parse(reader.result);

                resolve(error);
            };

            reader.onerror = () => {
                reject(error);
            };

            reader.readAsText(error.response.data);
        });
    },
};
